import { Injectable } from '@angular/core';
import { CacheConfig } from './caching';
import { WafConfig } from './waf-config';
import { LoggingConfig } from './app-config';
import { AnalyticsConfig } from './analytics-config';
import { LocaleConfig } from './locale-config';

@Injectable({
  providedIn: 'root',
})
export class EnvService {

  //TODO old
  public apiUrl = 'EMPTY_URL_PLACEHOLDER';
  public analyticsApi = 'EMPTY_ANALYTICS_URL_PLACEHOLDER'

  public theme: string;

  appBaseHref = '/';//'EMPTY_APP_BASE_HREF_PLACEHOLDER';
  appVersion = "EMPTY_APP_VERSION_PLACEHOLDER";
  apiConfig: { [key: string]: string };

  // Default used ONLY during build-time route extraction, when no tenant config
  // is loaded. At runtime appInitializer overwrites this from the tenant config,
  // so a tenant whose api.json is missing localeConfig sets it back to undefined
  // and still fails fast rather than being silently masked.
  localeConfig: LocaleConfig = { supportedLocales: ['ka', 'en', 'hy', 'ru', 'kk'], defaultLocale: 'ka' };

  public logConfig: LoggingConfig;
  public cacheConfig: CacheConfig;
  public wafConfig: WafConfig;
  public analyticsConfig: AnalyticsConfig;

  tenantId?: number = null;
  public enableDebug = false;
  public logLevel = 'info'
  public topGeOn = "true";
  public topgeId = "EMPTY_TOPGE_ID_PLACEHOLDER";
  public gtmId = "EMPTY_GTM_ID_PLACEHOLDER";

  constructor() {
    //TODO: read from config
    // this.cacheConfig = {
    //   enableServerCache: true,
    //   enableClientCache: true,
    //   defaultTtl: 60*5*100, // 5 minutes in seconds
    //   staticLookupTtl: 60 * 60 * 24 * 1000, // 2 hours
    //   dynamicLookupTtl: 60 * 5 * 1000, // 5 minutes
    //   staticConfigTtl: 60 * 60 * 24 * 1000, // 24 hours
    //   dynamicConfigTtl: 60 * 5 * 1000, // 5
    //   staticResourceTtl: 60 * 60 * 24 * 1000, // 1 hour
    //   dnamicResourceTtl: 60 * 5 * 1000, // 5 minutes
    // }
  }
}
